module.exports = __webpack_public_path__ + "static/media/msd.8e6654db.jpg";